// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__45wX5","colMaxWidth":"Table_colMaxWidth__v8MZt"};